import styled from "styled-components";

// Utils
import { media } from "utils/media";

// Components
import { Input, Button } from "components/spocketUI/";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-top: 20px;
  width: 500px;
  max-width: 100%;
`;

export const Text = styled.p`
  font-weight: 700;
  text-align: center;
  margin-bottom: 20px;
  font-size: 14px;
  line-height: 1.42857;
  color: #7e768f;
  max-width: 400px;
`;

export const Form = styled.form`
  width: 100%;
`;

export const FormContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  ${media.PHONE`
    flex-direction: column;
  `};
`;

export const StyledInput = styled(Input)`
  height: 38px;
  background: ${props => props.theme.colors.white.colorWhite};
  padding: 0 12px;
  box-sizing: border-box;
  font-weight: 500;
`;

export const StyledButton = styled(Button)`
  cursor: pointer;
  background-color: #774edd;
  color: #fff;
  border: none;
  font-weight: 500;
  white-space: nowrap;
  padding: 6px 62px;
  font-size: 14px;
  line-height: 1.42857;
  border-radius: 2px;
  box-shadow: 0 2px 2px 0 hsla(0, 0%, 60%, 0.14), 0 3px 1px -2px hsla(0, 0%, 60%, 0.2),
    0 1px 5px 0 hsla(0, 0%, 60%, 0.12);
  ${media.PHONE`
    width: 100%;
  `};
`;

export const ErrorText = styled.p`
  display: block;
  margin-top: 10px;
  margin-bottom: 0;
  color: #e83339;
  font-weight: 500;
  align-self: flex-start;
`;

export const SuccessText = styled.p`
  display: block;
  margin-top: 10px;
  font-weight: 500;
`;
